module.exports = __webpack_public_path__ + "static/media/whiteLogo.ccb9fecc.png";